import { GoogleAdsCampaign } from './google_ads';
import type { IGoogleAdsSearchCampaign } from './types';
import { CampaignClass } from './types';

export class GoogleAdsSearchCampaign extends GoogleAdsCampaign<IGoogleAdsSearchCampaign> {
  public override getDefaults(): Partial<IGoogleAdsSearchCampaign> {
    return {
      ...super.getDefaults(),
      _cls: CampaignClass.GoogleAdsSearch,
    };
  }
}
